// frontend/src/modules/guias/pages/GuiaDetalhes.js
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaPrint, FaCheck, FaFilePdf, FaWhatsapp, FaEnvelope, FaDownload } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';

function GuiaDetalhes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [guia, setGuia] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [gerandoPDF, setGerandoPDF] = useState(false);
  const printRef = useRef();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const token = localStorage.getItem('token');

  const fetchGuia = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/guia/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao buscar guia');
      const data = await response.json();
      setGuia(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGuia();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  const handleGerarPDF = () => {
    setGerandoPDF(true);
    window.print();
    setTimeout(() => setGerandoPDF(false), 1000);
  };

  const handleConfirmarPagamento = async () => {
    if (!window.confirm('Confirmar pagamento desta guia?')) return;
    try {
      const response = await fetch(`/api/guia/${id}/pagar`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          data_pagamento: new Date().toISOString().split('T')[0]
        })
      });
      if (!response.ok) throw new Error('Erro ao confirmar pagamento');
      setSuccess('✅ Pagamento confirmado com sucesso!');
      fetchGuia();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR');
  };

  const getTipoLabel = (tipo) => {
    const tipos = {
      'DARF': 'DARF - Imposto de Renda',
      'GPS': 'GPS - INSS',
      'GRP': 'GRP - FGTS',
      'DAS': 'DAS - Simples Nacional',
      'GRU': 'GRU - Taxas e Emolumentos',
      'GARE': 'GARE - ICMS/ISS',
      'OUTRO': 'Outro'
    };
    return tipos[tipo] || tipo;
  };

  const getStatusColor = (status) => {
    const colors = {
      'PENDENTE': '#fff3cd',
      'PAGO': '#d4edda',
      'VENCIDO': '#f8d7da',
      'CANCELADO': '#e2e3e5'
    };
    return colors[status] || '#e9ecef';
  };

  const getStatusColorText = (status) => {
    const colors = {
      'PENDENTE': '#856404',
      'PAGO': '#155724',
      'VENCIDO': '#721c24',
      'CANCELADO': '#383d41'
    };
    return colors[status] || '#6c757d';
  };

  const getTipoColor = (tipo) => {
    const colors = {
      'DARF': '#dc3545',
      'GPS': '#007bff',
      'GRP': '#28a745',
      'DAS': '#6f42c1',
      'GRU': '#fd7e14',
      'GARE': '#17a2b8',
      'OUTRO': '#6c757d'
    };
    return colors[tipo] || '#6c757d';
  };

  if (loading) return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <div style={{ fontSize: '48px' }}>🔄</div>
      <p style={{ fontSize: isMobile ? '14px' : '16px' }}>Carregando dados da guia...</p>
    </div>
  );

  if (error) return (
    <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>
      <div style={{ fontSize: '48px' }}>❌</div>
      <p style={{ fontSize: isMobile ? '14px' : '16px' }}>{error}</p>
      <button 
        onClick={() => navigate(-1)}
        style={{ 
          marginTop: '15px', 
          padding: isMobile ? '8px 20px' : '10px 20px', 
          backgroundColor: '#007bff', 
          color: 'white', 
          border: 'none', 
          borderRadius: '4px', 
          cursor: 'pointer',
          fontSize: isMobile ? '13px' : '14px',
          width: isMobile ? '100%' : 'auto'
        }}
      >
        Voltar
      </button>
    </div>
  );

  if (!guia) return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <div style={{ fontSize: '48px' }}>📄</div>
      <p style={{ fontSize: isMobile ? '14px' : '16px' }}>Guia não encontrada</p>
      <button 
        onClick={() => navigate('/guias')}
        style={{ 
          marginTop: '15px', 
          padding: isMobile ? '8px 20px' : '10px 20px', 
          backgroundColor: '#007bff', 
          color: 'white', 
          border: 'none', 
          borderRadius: '4px', 
          cursor: 'pointer',
          fontSize: isMobile ? '13px' : '14px',
          width: isMobile ? '100%' : 'auto'
        }}
      >
        Voltar para lista
      </button>
    </div>
  );

  return (
    <div style={{ padding: isMobile ? '10px' : '20px', maxWidth: '900px', margin: '0 auto' }}>
      {/* Cabeçalho com ações */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'stretch' : 'center', 
        marginBottom: '20px',
        flexWrap: 'wrap',
        gap: '10px'
      }} className="no-print">
        <button 
          onClick={() => navigate(-1)} 
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#007bff', 
            cursor: 'pointer', 
            fontSize: isMobile ? '14px' : '16px',
            padding: '10px 15px',
            borderRadius: '4px',
            transition: 'background 0.2s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: isMobile ? 'center' : 'flex-start',
            width: isMobile ? '100%' : 'auto'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        >
          <FaArrowLeft /> Voltar
        </button>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', width: isMobile ? '100%' : 'auto' }}>
          <button 
            onClick={handlePrint} 
            style={{ 
              padding: isMobile ? '8px 16px' : '10px 20px', 
              backgroundColor: '#28a745', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              justifyContent: 'center',
              fontSize: isMobile ? '13px' : '14px',
              flex: isMobile ? '1' : '0'
            }}
          >
            <FaPrint /> Imprimir
          </button>
          <button 
            onClick={handleGerarPDF} 
            style={{ 
              padding: isMobile ? '8px 16px' : '10px 20px', 
              backgroundColor: '#dc3545', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              justifyContent: 'center',
              fontSize: isMobile ? '13px' : '14px',
              flex: isMobile ? '1' : '0'
            }}
            disabled={gerandoPDF}
          >
            <FaFilePdf /> {gerandoPDF ? 'Gerando...' : 'Salvar PDF'}
          </button>
          {guia.status === 'PENDENTE' && (
            <button 
              onClick={handleConfirmarPagamento} 
              style={{ 
                padding: isMobile ? '8px 16px' : '10px 20px', 
                backgroundColor: '#007bff', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px', 
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                justifyContent: 'center',
                fontSize: isMobile ? '13px' : '14px',
                flex: isMobile ? '1' : '0'
              }}
            >
              <FaCheck /> Confirmar Pagamento
            </button>
          )}
        </div>
      </div>

      {/* Mensagens de sucesso/erro */}
      {success && (
        <div style={{ 
          backgroundColor: '#e8f5e9', 
          padding: isMobile ? '10px 15px' : '12px 20px', 
          borderRadius: '4px', 
          color: '#2e7d32', 
          marginBottom: '15px',
          border: '1px solid #c8e6c9',
          fontSize: isMobile ? '13px' : '14px'
        }} className="no-print">
          ✅ {success}
        </div>
      )}
      {error && (
        <div style={{ 
          backgroundColor: '#ffebee', 
          padding: isMobile ? '10px 15px' : '12px 20px', 
          borderRadius: '4px', 
          color: '#c62828', 
          marginBottom: '15px',
          border: '1px solid #ffcdd2',
          fontSize: isMobile ? '13px' : '14px'
        }} className="no-print">
          ❌ {error}
        </div>
      )}

      {/* Conteúdo da Guia - Para impressão */}
      <div 
        ref={printRef}
        style={{ 
          backgroundColor: 'white', 
          padding: isMobile ? '15px' : '30px', 
          borderRadius: '8px', 
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }} 
        id="guia"
      >
        {/* Cabeçalho com logo */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: isMobile ? '15px' : '25px',
          paddingBottom: isMobile ? '15px' : '20px',
          borderBottom: '2px solid #f0f0f0'
        }}>
          <div style={{ 
            display: 'inline-block',
            padding: isMobile ? '6px 12px' : '10px 20px',
            borderRadius: '8px',
            backgroundColor: getTipoColor(guia.tipo) + '15',
            color: getTipoColor(guia.tipo),
            fontSize: isMobile ? '12px' : '14px',
            fontWeight: 'bold',
            marginBottom: '10px'
          }}>
            {guia.tipo}
          </div>
          <h2 style={{ margin: '10px 0 5px 0', fontSize: isMobile ? '22px' : '28px' }}>📄 Guia de Pagamento</h2>
          <p style={{ color: '#6c757d', margin: '5px 0 0 0', fontSize: isMobile ? '14px' : '18px' }}>
            {getTipoLabel(guia.tipo)}
          </p>
          <span style={{
            display: 'inline-block',
            marginTop: '10px',
            padding: '4px 16px',
            borderRadius: '20px',
            backgroundColor: getStatusColor(guia.status),
            color: getStatusColorText(guia.status),
            fontWeight: 'bold',
            fontSize: isMobile ? '12px' : '14px'
          }}>
            {guia.status}
          </span>
        </div>

        {/* Dados da Guia */}
        <div style={{ marginBottom: isMobile ? '15px' : '25px' }}>
          <h3 style={{ 
            color: '#333', 
            marginBottom: '15px',
            fontSize: isMobile ? '16px' : '18px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            📋 Dados da Guia
          </h3>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
            gap: isMobile ? '10px' : '15px',
            backgroundColor: '#f8f9fa',
            padding: isMobile ? '15px' : '20px',
            borderRadius: '8px'
          }}>
            <div>
              <p style={{ margin: '0', color: '#6c757d', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Tipo</p>
              <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', fontSize: isMobile ? '13px' : '14px' }}>{getTipoLabel(guia.tipo)}</p>
            </div>
            <div>
              <p style={{ margin: '0', color: '#6c757d', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Competência</p>
              <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', fontSize: isMobile ? '13px' : '14px' }}>{guia.competencia}</p>
            </div>
            <div>
              <p style={{ margin: '0', color: '#6c757d', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Data de Vencimento</p>
              <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', fontSize: isMobile ? '13px' : '14px' }}>{formatDate(guia.data_vencimento)}</p>
            </div>
            <div>
              <p style={{ margin: '0', color: '#6c757d', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Valor</p>
              <p style={{ 
                margin: '5px 0 0 0', 
                fontWeight: 'bold', 
                fontSize: isMobile ? '20px' : '24px', 
                color: '#007bff'
              }}>
                {formatCurrency(guia.valor)}
              </p>
            </div>
            {guia.codigo_receita && (
              <div>
                <p style={{ margin: '0', color: '#6c757d', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Código da Receita</p>
                <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', fontFamily: 'monospace', fontSize: isMobile ? '13px' : '14px' }}>{guia.codigo_receita}</p>
              </div>
            )}
            {guia.valor_pago && (
              <div>
                <p style={{ margin: '0', color: '#6c757d', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Valor Pago</p>
                <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', color: '#28a745', fontSize: isMobile ? '13px' : '14px' }}>
                  {formatCurrency(guia.valor_pago)}
                </p>
              </div>
            )}
            {guia.data_pagamento && (
              <div>
                <p style={{ margin: '0', color: '#6c757d', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Data de Pagamento</p>
                <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', fontSize: isMobile ? '13px' : '14px' }}>{formatDate(guia.data_pagamento)}</p>
              </div>
            )}
          </div>
        </div>

        {/* Descrição e Observação */}
        {(guia.descricao || guia.observacao) && (
          <div style={{ marginBottom: isMobile ? '15px' : '25px' }}>
            <h3 style={{ 
              color: '#333', 
              marginBottom: '15px',
              fontSize: isMobile ? '16px' : '18px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              📝 Informações Adicionais
            </h3>
            <div style={{ 
              backgroundColor: '#f8f9fa',
              padding: isMobile ? '15px' : '20px',
              borderRadius: '8px'
            }}>
              {guia.descricao && (
                <div style={{ marginBottom: '10px' }}>
                  <p style={{ margin: '0', color: '#6c757d', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Descrição</p>
                  <p style={{ margin: '5px 0 0 0', fontSize: isMobile ? '13px' : '14px' }}>{guia.descricao}</p>
                </div>
              )}
              {guia.observacao && (
                <div>
                  <p style={{ margin: '0', color: '#6c757d', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Observação</p>
                  <p style={{ margin: '5px 0 0 0', fontSize: isMobile ? '13px' : '14px' }}>{guia.observacao}</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Código de Barras */}
        {guia.codigo_barras && (
          <div style={{ marginBottom: isMobile ? '15px' : '20px' }}>
            <h3 style={{ 
              color: '#333', 
              marginBottom: '15px',
              fontSize: isMobile ? '16px' : '18px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              📊 Código de Barras
            </h3>
            <div style={{ 
              padding: isMobile ? '15px' : '20px', 
              backgroundColor: '#f8f9fa', 
              borderRadius: '8px', 
              textAlign: 'center',
              border: '1px dashed #dee2e6'
            }}>
              <p style={{ 
                margin: '0', 
                fontFamily: 'monospace', 
                fontSize: isMobile ? '16px' : '22px', 
                letterSpacing: '2px',
                fontWeight: 'bold'
              }}>
                {guia.codigo_barras}
              </p>
            </div>
          </div>
        )}

        {/* Linha Digitável */}
        {guia.linha_digitavel && (
          <div style={{ marginBottom: isMobile ? '15px' : '20px' }}>
            <h3 style={{ 
              color: '#333', 
              marginBottom: '15px',
              fontSize: isMobile ? '16px' : '18px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              🔢 Linha Digitável
            </h3>
            <div style={{ 
              padding: isMobile ? '15px' : '20px', 
              backgroundColor: '#f8f9fa', 
              borderRadius: '8px', 
              textAlign: 'center',
              border: '1px dashed #dee2e6'
            }}>
              <p style={{ 
                margin: '0', 
                fontFamily: 'monospace', 
                fontSize: isMobile ? '14px' : '18px', 
                letterSpacing: '1px'
              }}>
                {guia.linha_digitavel}
              </p>
            </div>
          </div>
        )}

        {/* Rodapé com assinatura/validação */}
        <div style={{ 
          marginTop: isMobile ? '20px' : '30px', 
          paddingTop: isMobile ? '15px' : '20px', 
          borderTop: '2px solid #f0f0f0',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: isMobile ? 'center' : 'flex-end',
          flexWrap: 'wrap',
          gap: isMobile ? '10px' : '20px'
        }}>
          <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
            <p style={{ margin: '0', fontSize: isMobile ? '10px' : '12px', color: '#6c757d' }}>
              Documento gerado em: {new Date().toLocaleString('pt-BR')}
            </p>
            <p style={{ margin: '5px 0 0 0', fontSize: isMobile ? '10px' : '12px', color: '#6c757d' }}>
              Guia #{guia.id} • UUID: {guia.uuid ? guia.uuid.substring(0, 8) + '...' : 'N/A'}
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
              display: 'inline-block',
              padding: isMobile ? '8px 20px' : '10px 30px',
              border: '1px solid #dee2e6',
              borderRadius: '4px',
              textAlign: 'center',
              minWidth: isMobile ? '100px' : '150px'
            }}>
              <p style={{ margin: '0', fontSize: isMobile ? '10px' : '11px', color: '#6c757d' }}>Responsável</p>
              <p style={{ margin: '5px 0 0 0', fontWeight: 'bold' }}>_________________</p>
            </div>
          </div>
        </div>

        {/* QR Code para PIX (opcional) */}
        {guia.campos_extras?.pix_qr_code && (
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <h4 style={{ color: '#333', marginBottom: '10px', fontSize: isMobile ? '14px' : '16px' }}>💳 PIX</h4>
            <img 
              src={guia.campos_extras.pix_qr_code} 
              alt="QR Code PIX" 
              style={{ maxWidth: isMobile ? '150px' : '200px', maxHeight: isMobile ? '150px' : '200px' }}
            />
            <p style={{ fontSize: isMobile ? '11px' : '12px', color: '#6c757d', marginTop: '5px', wordBreak: 'break-all' }}>
              Copiar código PIX: {guia.campos_extras.pix_copia_e_cola || 'N/A'}
            </p>
          </div>
        )}
      </div>

      {/* Botão Voltar para lista no rodapé */}
      <div style={{ 
        marginTop: '20px', 
        display: 'flex', 
        justifyContent: 'center',
        gap: '15px'
      }} className="no-print">
        <button 
          onClick={() => navigate('/guias')}
          style={{ 
            padding: isMobile ? '8px 20px' : '10px 30px', 
            backgroundColor: '#6c757d', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontSize: isMobile ? '13px' : '14px',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          Ver Todas as Guias
        </button>
      </div>

      {/* Estilos para impressão */}
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
            body * {
              visibility: hidden;
            }
            #guia, #guia * {
              visibility: visible;
            }
            #guia {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              box-shadow: none !important;
              padding: 20px !important;
              background: white !important;
            }
            #guia .no-print {
              display: none !important;
            }
            button {
              display: none !important;
            }
            @page {
              margin: 1cm;
              size: A4;
            }
          }
          @media (max-width: 768px) {
            #guia {
              padding: 10px !important;
            }
            #guia h2 {
              font-size: 20px !important;
            }
            #guia h3 {
              font-size: 15px !important;
            }
          }
        `}
      </style>
    </div>
  );
}

export default GuiaDetalhes;